<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="fechar()"
>
    <ng-template pTemplate="header">
        <div class="flex justify-content-start">
            <span class="text-900 text-xl font-bold">
                <i class="pi pi-slack mr-1"></i>
                Serviços
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-table
            #tbServicos
            [value]="itens"
            dataKey="id"
            [paginator]="true"
            [lazy]="true"
            [rows]="pageRequest.size || 5"
            [first]="first"
            [totalRecords]="respostaPaginada?.totalElements || 0"
            [sortField]="campoOrdenacao"
            [sortOrder]="ordemOrdenacao"
            (onLazyLoad)="onLazyLoad($event)"
            [loading]="loading"
            [rowHover]="true"
            [showCurrentPageReport]="true"
            responsiveLayout="scroll"
            styleClass="p-datatable-sm"
            currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
        >
            <ng-template pTemplate="caption">
                <div class="flex justify-content-end flex-column sm:flex-row">
                    <div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input
                                pInputText
                                type="text"
                                #filter
                                [value]="valorFiltro"
                                (input)="buscar($event)"
                                placeholder="Buscar por codigo ou descricao"
                                class="w-full"
                            />
                        </span>
                        <span class="ml-2">
                            <button
                                pButton
                                type="button"
                                class="p-button-outlined"
                                icon="pi pi-filter-slash"
                                pTooltip="Limpar Filtros"
                                (click)="limpar()"
                            ></button>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="codigo">
                        <div class="flex align-items-center gap-2">
                            <span>Código</span>
                            <p-sortIcon field="codigo"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="descricao">
                        <div class="flex align-items-center gap-2">
                            <span>Descrição</span>
                            <p-sortIcon field="descricao"></p-sortIcon>
                        </div>
                    </th>
                    <th style="text-align: center">Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr>
                    <td>
                        <label>{{ item.codigo }}</label>
                    </td>
                    <td>
                        <label>{{ item.descricao }}</label>
                    </td>
                    <td style="text-align: center">
                        <button
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Detalhar"
                            icon="pi pi-fw pi-eye"
                            class="p-button-info mr-2"
                            (click)="abrirJanelaResumo(item)"
                        ></button>
                        <button
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Selecionar"
                            icon="pi pi-check"
                            class="p-button-success"
                            (click)="selecionarItem(item)"
                        ></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">Nenhum serviço encontrado.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="3">Carregando serviços. Por favor aguarde.</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>
</p-dialog>
